import React, { useEffect, useRef } from "react"
import { theme } from "antd"

import ShowUpgradeOptions from "./ShowUpgradeOptions"
import ContactOwnerPaywall from "./ContactOwnerPaywall"

const PaywallWrapper = ({
  children,
  payWallLogicData,
  sxProps,
  size = "default",
  open = true,
}) => {
  const {token} = theme.useToken()

  const parentRef = useRef(null)
  const paywallRef = useRef(null)

  const isContactOwner = payWallLogicData?.isContactOwner || false
  const isQuotaPayWall = payWallLogicData?.isQuotaPayWall || false
  const backdropSxProps = payWallLogicData?.backdropSxProps || {}

  useEffect(() => {
    if (!parentRef.current) return;
    const observer = new MutationObserver((mutations) => {
      
        
        mutations.forEach((mutation) => {
          
            mutation.removedNodes.forEach((node) => {
              if(paywallRef.current === node)
                parentRef.current.appendChild(node);
            });
        });
    });
    
    observer.observe(parentRef.current, { childList: true, subtree: true });

    return () => {observer.disconnect()};
}, [parentRef.current]);

  return (
    (
      <div
        ref={parentRef}
        style={{
          position: "relative",
          overflow: "hidden",
          minHeight: size === "default" ? 120 : 0,
          borderRadius: "8px",
          ...sxProps,
        }}
      >
        {children}
  
        {open && (
          <div
            style={{
              position: "absolute",
              top: 0,
              width: "100%",
              height: "100%",
              backgroundColor: token.colorBgBlur,
              backdropFilter: "blur(8px)",
              zIndex: 99,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              ...backdropSxProps,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                width: "100%",
                borderRadius: "8px",
              }}
              ref={paywallRef}
            >
              <PayWall
                size={size}
                isContactOwner={isContactOwner}
                isQuotaPayWall={isQuotaPayWall}
                payWallLogicData={payWallLogicData}
              />
            </div>
          </div>
        )}
      </div>
    )
  )
}

const PayWall = ({
  size,
  isContactOwner,
  isQuotaPayWall,
  payWallLogicData,
}) => {
  if (isContactOwner) {
    return <ContactOwnerPaywall />
  } else if (isQuotaPayWall) {
    return (
      <ShowUpgradeOptions
        plans={payWallLogicData?.info?.plans}
        addOns={payWallLogicData?.info?.addOns}
        size={size}
        title={payWallLogicData?.info?.title}
        message={
          payWallLogicData?.info?.description ||
          "You have exceeded your quota. Please subscribe to a plan or purchase addons from the list given below to increase your quota"
        }
        btnData={payWallLogicData?.info?.button}
      />
    )
  } else {
    return (
      <ShowUpgradeOptions
        plans={payWallLogicData?.info?.plans}
        addOns={payWallLogicData?.info?.addOns}
        title={payWallLogicData?.info?.title}
        message={payWallLogicData?.info?.description}
        size={size}
        btnData={payWallLogicData?.info?.button}
      />
    )
  }
}

export default PaywallWrapper
